import React from 'react';
import { Container } from 'react-bootstrap';

import { DATENSTAND } from "../../config/constants";

const Aktuelles = () => (
  <Container className="mt-4">
    <h2 className="section-title">Krebs in Sachsen-Anhalt</h2>
    <div className="section-title-underline"></div>

    <div className="aktuelles-text mb-4" style={{ fontSize: '1.08rem', lineHeight: '1.6' }}>
      <p>
        Herzlich Willkommen auf den Seiten des interaktiven Berichts des Krebsregisters Sachsen-Anhalts (KR-LSA). Hier finden Sie umfassende, bevölkerungsbasierte Informationen zum Krebsgeschehen in Sachsen-Anhalt. Die Datengrundlage hierfür bilden die Meldungen aus den medizinischen Versorgungseinrichtungen für Krebspatientinnen und -patienten.
      </p>

      <p>
        Der Bericht beinhaltet sowohl epidemiologische Auswertungen zu Häufigkeit, regionaler Verteilung und Überlebenszeiten von Krebserkrankungen als auch klinische Auswertungen zur Diagnose und den durchgeführten Therapien.
      </p>

      <p>
        Die vorliegende Fassung beinhaltet sämtliche Meldungen, die bis zum {DATENSTAND} im KR-LSA dokumentiert wurden. Der Bericht wird regelmäßig aktualisiert, um eingehende Meldungen fortwährend zu berücksichtigen.
      </p>

      <p>
        Detaillierte Informationen zur Krebsregistrierung finden Sie auf unserer Homepage. Bei Fragen oder Kommentaren zum Bericht oder zur Krebsregistrierung im Allgemeinen,{' '}
        <a href="https://www.kr-lsa.de/kontakt" target="_blank" rel="noopener noreferrer">
          kontaktieren
        </a>{' '}
        Sie uns gern. Wenn Sie über aktuelle Entwicklungen im Krebsregister Sachsen-Anhalt (KR-LSA) informiert bleiben möchten, empfehlen wir Ihnen zudem unseren{' '}
        <a href="https://www.kr-lsa.de/aktuelles/newsletter" target="_blank" rel="noopener noreferrer">
          Newsletter
        </a>.
      </p>
    </div>
  </Container>
);

export default Aktuelles;
